const requireModuleTypes = require.context('./modules/', true, /types\.js$/);

let allTypes = {};
let allTypesNamespaced = {};

function toLowerFirst(string) {
  return string.charAt(0).toLowerCase() + string.slice(1);
}

requireModuleTypes.keys().forEach((fileName) => {
  if (fileName === './index.js') { return; }
  const namespace = fileName.replace(/(\.\/|types\.js|\/)/g, '');
  const types = requireModuleTypes(fileName);
  allTypes = { ...allTypes, ...types.default };
  const namespaced = {};
  Object.keys(types.default).forEach((key) => {
    namespaced[key] = `${namespace}/${key}`;
  });
  allTypesNamespaced = { ...allTypesNamespaced, ...namespaced };
});

const VT = { ...allTypes };
const VTN = { ...allTypesNamespaced }; // Types with module name prefixed
export { VT, VTN };
export default VT;
